<div [style.padding]="linePadding">
    <div>
        <vsf-title-box
            [titleInfo]="titleInfo"
            [forComponent]="true">
        </vsf-title-box>
    </div>
    <div class="md:grid md:grid-cols-2 md:gap-x-[28px] md:items-start md:mt-12">
        <div class="md:top-1 md:sticky">
            <div class="media-card rounded-sm">
                <vsf-asset-swiper-gallery-v2
                    [assets]="variantAssets"
                    [displayThumbnails]="displayThumbnails"
                    [selectedAssetId]="selectedAsset?.id"
                    [arrowType]="arrowType">
                </vsf-asset-swiper-gallery-v2>
            </div>
        </div>
        <div class="px-0 mt-8 px-2 md:mt-0">
            <div *ngIf="displayFeaturedReview && product?.customFields?.displayFeaturedReview" class="mb-6">
                <vsf-product-review-card
                    *ngIf="product?.customFields?.featuredReview"
                    [review]="product.customFields.featuredReview"
                    class="mb-6"
                ></vsf-product-review-card>
            </div>
            <h1>
                <div class="product-name mb-2">
                    {{product?.name}}
                </div>
                <div *ngIf="displayProductSubtitle" class="product-subtitle mb-2">
                    {{product?.customFields.ProductSubtitle}}
                </div>
            </h1>
            <div *ngIf="displaySku && selectedVariant?.sku" class="product-sku text-gray-400 mb-4">
              <h2>SKU: {{getSku()}}</h2>
            </div>
            <div *ngIf="(isMobile===false)" class="flex items-center mb-2">
                <ng-container *ngIf="selectedVariantMSRP && discountPercentage">
                    <p class="mrsp-price text-gray-400 mr-2 line-through">
                        <span >{{ (selectedVariantMSRP | separatedFormatPrice)?.currency }}</span>
                        <span >{{ (selectedVariantMSRP | separatedFormatPrice)?.price }}</span>
                    </p>
                </ng-container>
                <p class="product-price mr-4 font-bold flex items-baseline text-[#242424]">
                    <span class="currency-tag">{{ (selectedVariant?.price | separatedFormatPrice)?.currency }}</span>
                    <span class="product-price">{{ (selectedVariant?.price | separatedFormatPrice)?.price }}</span>
                </p>
                <ng-container *ngIf="selectedVariantMSRP && discountPercentage">
                    <span
                      class="save-badge flex items-center rounded-md px-2 py-1 text-xs font-semibold text-white bg-[#F85858] whitespace-nowrap">
                      SAVE {{ discountPercentage | number:'1.0-0' }}%
                    </span>
                </ng-container>
            </div>
            <div *ngIf="displayReviewInfo && product?.customFields?.reviewCount > 0">
                <vsf-product-review-indicator
                    class="mb-6"
                    [inputScore]="product?.customFields?.reviewRating"
                    [inputReviewNumber]="product?.customFields?.reviewCount"
                >
                </vsf-product-review-indicator>
            </div>
            <div *ngIf="product?.customFields?.salesNumber && product?.customFields?.salesStatement">
                <span>{{product?.customFields?.salesNumber}}{{product?.customFields?.salesStatement}}</span>
            </div>

            <div class="mt-4 space-y-6" *ngIf="displayProductOptions && displayOptionGroups.length > 0">
                <div *ngFor="let optionGroup of displayOptionGroups; let i = index" class="option-group-container">

                    <ng-container *ngIf="optionGroup.displayType !== 'radio-list-with-price'; else radioListWithPriceTitle">
                        <label [for]="'option-group-' + i" class="option-group-label block text-sm font-normal text-gray-600 mb-1">
                            {{ optionGroup.group.name }}:
                            <span *ngIf="optionGroup.displayType !== 'dropdown'" class="text-base font-bold text-gray-700 ml-1">
                                {{ getSelectedOptionName(i) }}
                            </span>
                        </label>
                    </ng-container>

                    <div [ngSwitch]="optionGroup.displayType" class="option-controls mt-2">

                        <select *ngSwitchCase="'dropdown'"
                                [id]="'option-group-' + i"
                                [name]="'option-group-' + i"
                                [ngModel]="optionGroup.selectedOptionCode"
                                (ngModelChange)="onOptionChange(i, $event)"
                                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300
                                    focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm
                                    rounded-md option-dropdown truncate">
                            <option *ngFor="let option of optionGroup.options"
                                [value]="option.code"
                                [attr.title]="getOptionTooltip(i, option.code, option.name)">
                                {{ option.name }}
                            </option>
                            <option *ngIf="optionGroup.options.length === 0" disabled value="" class="text-sm text-gray-500 italic">
                                No options available for current selection.
                            </option>
                        </select>

                        <div *ngSwitchCase="'tiles'"
                              class="flex flex-wrap gap-2 option-tiles-container">
                              <div *ngFor="let option of optionGroup.options"
                                   (click)="onOptionChange(i, option.code)"
                                   class="option-tile border rounded-md overflow-hidden"
                                   [class.selected]="optionGroup.selectedOptionCode === option.code"
                                   [title]="option.name"
                                   [attr.title]="getOptionTooltip(i, option.code, option.name)">
                                  <ng-container *ngIf="getVariantImageForTile(i, option.code) as tileImage; else emptyTileIcon">
                                      <img [src]="tileImage | assetPreview:'thumb':'webp'"
                                           [alt]="option.name"
                                           class="h-14 w-14 object-cover pointer-events-none"
                                           >
                                  </ng-container>
                                  <ng-template #emptyTileIcon>
                                      <div class="h-14 w-14 flex items-center justify-center bg-gray-100 text-gray-400">
                                          <fa-icon icon="image" class="text-2xl"></fa-icon>
                                      </div>
                                  </ng-template>
                              </div>
                              <div *ngIf="optionGroup.options.length === 0" class="text-sm text-gray-500 italic">
                                   No options available for current selection.
                              </div>
                        </div>
                        <div *ngSwitchCase="'big-tiles'"
                                class="flex flex-wrap gap-2 option-tiles-container big">
                            <div *ngFor="let option of optionGroup.options"
                                (click)="onOptionChange(i, option.code)"
                                class="option-tile border rounded-md overflow-hidden"
                                [class.selected]="optionGroup.selectedOptionCode === option.code"
                                [attr.title]="getOptionTooltip(i, option.code, option.name)">
                                <ng-container *ngIf="getVariantImageForTile(i, option.code) as tileImage; else emptyBigTileIcon">
                                    <img [src]="tileImage | assetPreview:'thumb':'webp'"
                                        [alt]="option.name"
                                        class="object-cover pointer-events-none">
                                </ng-container>
                                <ng-template #emptyBigTileIcon>
                                    <div class="empty-icon-container bg-gray-100 text-gray-400">
                                    <fa-icon icon="image"></fa-icon>
                                    </div>
                                </ng-template>
                            </div>

                            <div *ngIf="optionGroup.options.length === 0" class="text-sm text-gray-500 italic">
                                No options available for current selection.
                            </div>
                        </div>

                        <div *ngSwitchCase="'options'"
                               class="flex flex-wrap gap-2 option-buttons-container">
                            <button *ngFor="let option of optionGroup.options"
                                    type="button"
                                    (click)="onOptionChange(i, option.code)"
                                    class="option-button px-3 py-1 border rounded text-sm md:text-base truncate max-w-[150px]"
                                    [class.selected]="optionGroup.selectedOptionCode === option.code"
                                    [attr.title]="getOptionTooltip(i, option.code, option.name)">
                                {{ option.name }}
                            </button>
                            <div *ngIf="optionGroup.options.length === 0" class="text-sm text-gray-500 italic">
                                No options available for current selection.
                            </div>
                        </div>

                        <div *ngSwitchCase="'options-with-price'"
                            class="flex flex-wrap gap-2">
                            <div *ngFor="let option of optionGroup.options"
                                (click)="onOptionChange(i, option.code)"
                                class="flex flex-col w-28 h-20 cursor-pointer
                                    border rounded-md overflow-hidden text-center transition-colors"
                                [attr.title]="getOptionTooltip(i, option.code, option.name)"
                                [ngClass]="{
                                    'border-primary-500' : optionGroup.selectedOptionCode === option.code,
                                    'border-gray-300'   : optionGroup.selectedOptionCode !== option.code
                                }">
                                <div class="basis-1/2 flex items-center px-2
                                    text-left text-sm md:text-base font-semibold leading-tight"
                                    [ngClass]="{
                                        'bg-primary-500 text-white font-bold' : optionGroup.selectedOptionCode === option.code,
                                        'bg-gray-100 text-gray-900': optionGroup.selectedOptionCode !== option.code
                                    }">
                                    <span class="truncate">
                                        {{ option.name }}
                                    </span>
                                </div>
                                <div class="basis-1/2 flex items-center px-2
                                    text-left text-sm md:text-base"
                                    [ngClass]="{
                                        'bg-primary-100 text-primary-900' : optionGroup.selectedOptionCode === option.code,
                                        'bg-white text-gray-700'          : optionGroup.selectedOptionCode !== option.code
                                    }">
                                    <span>{{ (getPriceForOption(i, option.code) | separatedFormatPrice)?.currency }}</span>
                                    <span>{{ (getPriceForOption(i, option.code) | separatedFormatPrice)?.price }}</span>
                                </div>
                            </div>
                            <div *ngIf="optionGroup.options.length === 0"
                                class="text-sm text-gray-500 italic">
                                No options available for current selection.
                            </div>
                        </div>

                        <div *ngSwitchCase="'radio-list-with-price'" class="space-y-2">
                            <div  *ngFor="let option of optionGroup.options"
                                  (click)="onOptionChange(i, option.code)"
                                  class="flex items-center justify-between rounded-lg border p-3 cursor-pointer
                                         transition-colors"
                                  [attr.title]="getOptionTooltip(i, option.code, option.name)"
                                  [ngClass]="{
                                      'ring-2 ring-primary-500 border-primary-500' : optionGroup.selectedOptionCode === option.code,
                                      'border-gray-300 hover:border-gray-400'      : optionGroup.selectedOptionCode !== option.code
                                  }">

                                <div class="mr-3 flex items-center justify-center">
                                    <input  type="radio"
                                            [name]="'option-group-' + i"
                                            [value]="option.code"
                                            [checked]="optionGroup.selectedOptionCode === option.code"
                                            class="h-5 w-5 text-primary-500 border-gray-300 cursor-pointer">
                                </div>

                                <div class="flex-1">
                                    <div class="flex flex-wrap items-center gap-x-2">
                                        <p class="text-[14px] md:text-[16px] font-bold
                                            text-gray-900 truncate max-w-[250px] mr-1">
                                            {{ option.name }}
                                        </p>
                                        <p *ngIf="getVariantSubtitle(i, option.code) as tag"
                                            class="items-center rounded-sm bg-gray-300 text-[8px]
                                                md:text-[10px] px-1 py-0.5 text-[#242424] shrink-0"
                                            [attr.title]="tag">
                                            {{ tag }}
                                        </p>
                                    </div>
                                </div>

                                <div class="text-right pl-3 min-w-[5rem] items-end">
                                    <p class="leading-none text-base font-bold text-gray-900 mb-1">
                                        <span class="text-[14px] md:text-[16px]">
                                            {{(getPriceForOption(i, option.code) | separatedFormatPrice)?.currency+(getPriceForOption(i, option.code) | separatedFormatPrice)?.price}}
                                        </span>
                                    </p>
                                    <p *ngIf="getMsrpPriceForOption(i, option.code) as msrp"
                                       class="text-12px md:text-[14px] text-gray-400 line-through">
                                       {{ (msrp | separatedFormatPrice)?.currency+(msrp | separatedFormatPrice)?.price}}
                                    </p>
                                </div>
                            </div>

                            <div *ngIf="optionGroup.options.length === 0"
                                 class="text-sm italic text-gray-500">
                                No options available for current selection.
                            </div>
                        </div>

                        <div *ngSwitchDefault>
                            Unsupported display type: {{ optionGroup.displayType }}
                        </div>
                    </div>
                </div>
            </div>
            <!-- Print template selector: shown when ≥ 1 template exists -->
            <div *ngIf="variantPrintTemplates?.length > 0"
                class="mt-6 space-y-2 print-template-container">
                <label class="text-sm font-normal text-gray-600 mb-1">
                    <ng-container *ngIf="variantPrintTemplates.length > 1">
                        Templates:
                        <span class="text-base font-bold text-gray-700 ml-1">
                            {{ selectedPrintTemplate?.name }}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="variantPrintTemplates.length === 1">
                        {{ variantPrintTemplates[0].name }}
                    </ng-container>
                </label>

                <div *ngIf="variantPrintTemplates.length > 1" class="flex flex-wrap gap-2">
                    <div *ngFor="let tpl of variantPrintTemplates"
                        (click)="onPrintTemplateChange(tpl)"
                        [title]="tpl.name"
                        class="relative cursor-pointer overflow-hidden rounded-md border transition-colors duration-200 flex flex-col items-center"
                        [ngClass]="{
                            'pointer-events-none ring-2 ring-primary-600' : selectedPrintTemplate?.id === tpl.id,
                            'border-gray-300 hover:border-gray-400'      : selectedPrintTemplate?.id !== tpl.id,
                        }">
                        <div>
                            <img [src]="tpl.previewAsset | assetPreview:'thumb':'webp'"
                                [alt]="tpl.name"
                                class="block aspect-[1/1] object-cover"
                                [ngClass]="templateDisplaySize === 'large'
                                    ? 'w-[120px] h-[120px]'
                                    : 'w-14 h-14'">
                        </div>
                        <span *ngIf="templateDisplaySize === 'large'"
                            class="mt-1 truncate text-center text-xs text-gray-600">
                            {{ tpl.name }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Custom options displayed on PDP (message inputs and paid option selectors) -->
            <!-- Only rendered when there are no print templates requiring the modal -->
            <vsf-product-inline-custom-options
                *ngIf="variantPrintTemplates.length === 0"
                [allCustomizationOptions]="allCustomizationOptions"
                [messageValues]="messageValues"
                [selectedPaidOptionValues]="selectedPaidOptionValues"
                (messageChange)="onMessageChange($event.optionId, $event.value)"
                (paidOptionChange)="onPaidOptionChange($event.optionId, $event.key)">
            </vsf-product-inline-custom-options>

            <div *ngIf="(isMobile===false) || (!isProductPage)"
                #shopNowBanner
                class="mt-4"
            >
                <vsf-product-shop-now-banner
                    [product]="product"
                    [selectedVariant]="selectedVariant"
                    [selectedPrintTemplate]="selectedPrintTemplate"
                    [inStock]="inStock"
                    [isMobile]="isMobile"
                    [messageValues]="messageValues"
                    [selectedPaidOptionValues]="selectedPaidOptionValues"
                    [allCustomizationOptions]="allCustomizationOptions"
                >
                </vsf-product-shop-now-banner>
            </div>
            <div *ngIf="displayPaymentCapabilities && paymentCapabilities?.length > 0" class="mt-2 mb-2">
                <vsf-payment-icon-strip
                    [capabilities]="paymentCapabilities">
                </vsf-payment-icon-strip>
            </div>
            <div *ngIf="displayProductDescription && product?.description">
                <span class="text-base text-gray-700 rich-text-content"
                    [innerHTML]="product?.description | safeHtml">
                </span>
            </div>
            <div *ngIf = "displayProductKeyPoints">
              <div *ngIf="keySellingPointList && keySellingPointList.keyPoints.length > 0"
                class="mt-2 mb-2">
                <vsf-key-selling-points-banner
                    [titleFontSize]="keySellingPointList.titleFontSize"
                    [subtitleFontSize]="keySellingPointList.subtitleFontSize"
                    [textFontSize]="keySellingPointList.textFontSize"
                    [titleAlignment]="keySellingPointList.titleAlignment"
                    [textAlignment]="keySellingPointList.textAlignment"
                    [iconSize]="keySellingPointList.iconSize"
                    [keySellingPoints]="keySellingPointList.keyPoints"
                    [layout]="'horizontal'"
                    [mobileLayout]="'horizontal'"
                    [backgroundColor]="keySellingPointList.backgroundColor"
                    [textColor]="keySellingPointList.textColor"
                    [listLayout]="'vertical'"
                    [separatedBackground]="true"
                    [isMobile]="isMobile"
                >
                </vsf-key-selling-points-banner>
              </div>

              <div *ngIf="displayProductFeatures && productFeatures.length > 0">
                <div *ngFor="let feature of productFeatures" class="mt-4 bg-gray-100 rounded-lg">
                    <div class="flex items-center justify-between cursor-pointer px-4 py-2" (click)="toggleFold(feature.title)">
                        <h2 class="text-gray-600 font-bold" [innerHTML]="feature.title | safeHtml"></h2>
                        <fa-icon [icon]="isFolded(feature.title) ? 'plus' : 'minus'"></fa-icon>
                    </div>
                    <div class="text-gray-500 space-y-1 px-4" [@expandCollapse]="isFolded(feature.title) ? 'collapsed' : 'expanded'">
                        <span class="rich-text-content" [innerHTML]="feature.text | safeHtml"></span>
                    </div>
                </div>
              </div>
            </div>
            <div *ngIf="displayProductPageEntry && product">
                <a class="link product__view-details animate-arrow block mt-8 text-primary-600 font-medium"
                    [href]="getProductPageUrl()">
                    View full details →
                </a>
            </div>
        </div>
    </div>
</div>
